import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { environment } from '../../../environments/environment';

function initFirebase() {
  const firebaseApp = initializeApp(environment.firebase);

  if (environment.urlHostName === 'api.narravero.dev') {
    (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }

  const appCheck = initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaEnterpriseProvider(environment.appCheck.recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  });

  (window as any).__appCheck = appCheck;
}

initFirebase();

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
